import React from 'react';
import styled from 'styled-components';
import PersonIcon from '@material-ui/icons/Person';

const FotoContainer = styled.span`
  grid-area: foto;
  border-radius: 50%;
  width: 90px;
  height: 90%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  & > img {
    width: 70%;
    height: 100%;
    text-align: center;
    object-fit: cover;
    margin-top: 10px;
  }
`

function Foto (props) {
  let { src } = props;
  return (
    <FotoContainer title={!src && "Sem foto"}>
      {src ? (
        <img src={src} alt=""/>
      ) : (
        <PersonIcon fontSize="large" />
      )}
    </FotoContainer>
  )
}

export default Foto;
